export default __webpack_public_path__ + "static/media/img-b-result-distance-it_it@3x.7df7a467.jpg";